import type { SectionTitle } from './OnboardingPage';

/**
 * A step's own caption — what the step is for, in the design's words (`camera-feeds-page-stage`,
 * R1). It is the step's status line in the nav bar, after its title, in place of the launch note
 * (`onboarding-persistent-scene-step-titles`, R1.3: one status line, the caption first).
 *
 * Keyed on the step's TITLE, exactly as `launchNote.ts` is and for the same reasons: the index map
 * lives inside the page module, and the type-only `SectionTitle` import makes a renamed title fail
 * the type check rather than silently drop a caption. A later page adds its caption by adding an
 * entry here.
 */
const STEP_CAPTION: Readonly<Partial<Record<SectionTitle, string>>> = {
  // Frames 06 and 07 (`twin-details-page-hours-week`). No launch note: like Twin details, it saves at once.
  'Opening hours': 'Saved to the twin straight away, not launched',
  'Camera Feeds': 'Optional. Cameras on the plan tell the Observers step what each stream can see.',
  // Ruled by Rob 2026-10-27 (`retire-edit-mode-position-write-path`): the step now saves at once.
  'Position twin': 'Saved to the twin straight away',
};

/** The caption for the step titled `title`, or `null` for a step that carries none. */
export const stepCaption = (title: string | null): string | null =>
  // `hasOwn`, not a bare index: a title is a string, and `Object.prototype` answers `constructor`.
  title !== null && Object.prototype.hasOwnProperty.call(STEP_CAPTION, title)
    ? (STEP_CAPTION[title as SectionTitle] ?? null)
    : null;
